import { useEffect } from 'react';

/**
 * 드래그 시 클릭 이벤트 방지
 * @param {HTMLElement} dom - 이벤트를 적용할 DOM
 * @param {string} tag - DOM안에있는 이벤트를 적용할 태그(ex: 'div', 'li' ...etc)
 * @param {Array<any>} dependency - useEffect dependency
 */
const useDragPreventClick = (
	dom: HTMLElement | null,
	tag: string,
	dependency_array: Array<any>,
) => {
	/** mousedown이 발생한 지점과 click이 발생한 지점이 다를 경우 클릭 이벤트가 발생하지 않게 처리 */
	useEffect(() => {
		if (!dom) return;

		const arr = dom.getElementsByTagName(tag);

		for (let i = 0; i < arr.length; i++) {
			let x: number;
			arr[i].addEventListener('mousedown', (e: Event) => {
				const _e = e as MouseEvent;
				x = _e.clientX;
			});
			arr[i].addEventListener('click', (e: Event) => {
				const _e = e as MouseEvent;
				if (_e.clientX !== x) _e.stopImmediatePropagation();
			});
		}
		return () => {
			for (let i = 0; i < arr.length; i++) {
				let x: number;
				arr[i].removeEventListener('mousedown', (e: Event) => {
					const _e = e as MouseEvent;
					x = _e.clientX;
				});
				arr[i].removeEventListener('click', (e: Event) => {
					const _e = e as MouseEvent;
					if (_e.clientX !== x) _e.stopImmediatePropagation();
				});
			}
		};
	}, [dom, tag, ...dependency_array]);
};

export default useDragPreventClick;
